let appName = 'QiDi Technology'

module.exports = {
    name: appName,
    languagezh: 'Chinese',
    languageen: 'English',
    homeRouter: 'Home',
    cheatdefenderRouter: 'CheatDefender',
    aboutRouter: 'About us',
    contactRouter: 'Contact us',
    footer: 'Shanghai' + appName + ' company limited',
    home: {
        bannerTitle: 'One stop product technology solutions',
        text1: 'Design and development services for Internet projects from 0 to 1',
        text2: 'Cumulative online cases 40+',
        module1: {
            title: 'Service support',
            titleDesc: 'Brand building, group building, marketing website, platform website, responsive website, mobile website, multimedia H5 design and development',
        },
        moduleList1: {
            title1: 'Mobile design and development',
            text1: 'According to the demand design style, customized development solutions, from design to development, functional requirements to test online, efficient delivery.',
            title2: 'Interaction design',
            text2: 'Based on user experience, human-computer interaction can make users feel happy when using products and create user viscosity.',
            title3: 'High end website customization',
            text3: 'Professional design and development team and process specification, so that all enterprises have a set of high-end website in the shortest time.',
            title4: 'Optimize operation',
            text4: 'Data analysis drives product strategy and launch management to make business direction planning more intelligent.',

        },
        module2: {
            title: 'Excellent cases',
            titleDesc: 'Perfect integration of business planning, creative arts, Internet technology and marketing data analysis'
        },
        moduleList2: {
            title1: 'Human dog translator APP',
            title2: 'FT micro care APP',
            title3: 'Yilian housekeeping APP',
            title4: 'More free version of split APP',
            title5: 'Legal financial official Website',
            title6: 'Xinghe science and technology official Website',
        },
        module3: {
            title: 'About us',
            titleDesc: 'Committed to providing users with easy-to-use, beautiful, innovative high-value products and services'
        },
        moduleList3: {
            text1: 'ShangHai' + appName + 'Ltd., established in 2017, is a professional company of Internet technology services. It has strong industry information and project implementation capabilities, and is committed to providing users with easy-to-use, beautiful and innovative high-value products and services. QiDi insists on creating more business value for customers, and through the combination of Internet technology and industry, it accelerates industry innovation, promotes growth, optimizes operation, improves efficiency, upgrades customer experience, and helps customers create more business value. QiDi provides leading digital consulting, user experience design, technology implementation and operation services. It has rich precipitation in project management and delivery. With deep accumulation in high-tech, finance, education, consumption, sharing, intelligent hardware, big data and other industries, QiDi has established long-term cooperative relations with many excellent enterprises.',
            text2: 'Learn more',
        },

        module4: {
            title: 'Our strengths',
            titleDesc: 'High end website for your low quality industry'
        },
        moduleList4: {
            title1: 'Rich experience',
            text1: 'Services for different industry projects, consistent industry praise.',
            title2: 'Fast landing',
            text2: 'According to the demand, implement the product related matters, and launch the product quickly',
            title3: 'Continuous update',
            text3: 'Cooperate with the enterprise demand and development planning, upgrade and optimize the products.',
            title4: 'High quality service',
            text4: 'Professional and efficient service team, quick response',
        },
        module5: {
            title: 'Cooperative partner',
            titleDesc: 'With a cross domain Internet sense of smell, create miracles with users'
        },
        moduleList5: {
            text1: 'LegCo Finance',
            text2: 'Carefree housekeeping',
            text3: 'Shunfan management',
            text4: 'Shanruo Technology',
            text5: 'Xinghe Technology',
            text6: 'Aishang house',
            text7: 'Yilian Finance',
            text8: 'IQI culture'
        },

    },
    solve: {
        bannerTitle: 'Game Anti-Cheat Solution',
        text1: 'Cheatdefender is an industry-leading cheating',
        text2: 'defense solution for network applications',
        module1: {
            title: 'CheatDefender',
            titleDesc: 'Packet encryption and decryption',
        },
        moduleList1: {
            text1: "CheatDefender is a complete online game anti-cheat solution built upon production-level software protection system.It features code obfuscation, mutation and virtualization, runtime anti-debug and code integrity enforcement Dynamic code delivery for secured C/S mode anti-cheat and game data transfer",
        },
        module2: {
            title: 'CheatDefender Introduction'
        },
        moduleList2: {
            title1: 'Packet Encryption',
            text1: 'Fundamental function to prevent your game data being analyzed and tampered by tools like WPE',
            title2: 'Preventing Packet Replay',
            text2: 'Skilled hackers will exploit game mechanism by using packet replay, even with encrypted packets. CheatDefender’s packet encryption is immune to such attacks ',
            title3: 'Client Code and Memory Integrity',
            text3: 'Anti-cheat code dynamically delivered by server can detect runtime tampering to your game client code or memory',
            title4: 'Speed Hack Detection',
            text4: 'CheatDefender protects timing functions being altered by detecting on both client and server side',
            title5: 'Runtime Scanning',
            text5: 'Anti-cheat code dynamically delivered by server can scan game clients’ memory for any malicious code injections',
            title6: 'On-The-Fly Update',
            text6: 'CheatDefender featuring unique updating technology, delivering new detection code without affecting any player experience',
        },

        module3: {
            title: 'CheatDefender Architecture'
        },
        moduleList3: {
            text1: 'Server -> Client',
            text2: 'Client -> Server',
        },
        module4: {
            title: 'Contact Us',
            titleDesc: 'We will be happy to solve any problems for you',
        },

        moduleList4: {
            text1: "E-mail:",
            text2: "Oversea Marketing Manager's E-mail:"
        }

    },
    about: {
        bannerTitle: 'About us',
        text1: 'Committed to providing users with easy-to-use, beautiful, innovative high-value products and services',
        module1: {
            title: 'Our team',
        },
        moduleList1: {
            text1: 'ShangHai' + appName + 'Ltd., established in 2017, is a professional company of Internet technology services. It has strong industry information and project implementation capabilities, and is committed to providing users with easy-to-use, beautiful and innovative high-value products and services. QiDi insists on creating more business value for customers, and through the combination of Internet technology and industry, it accelerates industry innovation, promotes growth, optimizes operation, improves efficiency, upgrades customer experience, and helps customers create more business value. QiDi provides leading digital consulting, user experience design, technology implementation and operation services. It has rich precipitation in project management and delivery. With deep accumulation in high-tech, finance, education, consumption, sharing, intelligent hardware, big data and other industries, QiDi has established long-term cooperative relations with many excellent enterprises.',
            text2: 'The team members have working experience in well-known IT and Internet enterprises at home and abroad, and have rich development and management experience and advantages in technology research and development, project management, product operation and other fields. It not only has a broad vision and global thinking mode, but also has a deep understanding of localization and regional needs.',
            text3: 'Professional elites',
            text4: 'Famous brands',
            text5: 'Project experience (years)'
        },
        module2: {
            title: 'Corporate culture',
        },
        moduleList2: {
            text1: 'Willing to share',
            text2: 'Fast implementation',
            text3: 'Keep curious',
            text4: 'Trust colleagues and customers'
        },
        module3: {
            title: 'Our future',
        },
        moduleList3: {
            text1: 'In the next five years, QiDi insists on "user experience first" and "Internet plus" to drive the development of the industry. It aims to create an ecological Internet platform actively, focusing on developing products and applications in the fields of digital content development, enterprise management SAAS platform, big data application and intelligent Internet of things.',
        },
    },
    contact: {
        bannerTitle: 'Contact us',
        text1: 'Excellent quality, business excellence, to provide you with the most sincere service',
        module1: {
            title: 'Shanghai' + appName + ' company limited',
        },
        moduleList1: {
            phone: '13402089914',
            email: '2090623970(at)qq.com',
            text1: 'Address: Room A2101, Rongmei Road 158th, Songjiang District, Shanghai',
            text2: 'Postcode: 201600'
        }
    },
}